import { IconButton } from '@cian/ui-kit';
import { IconToggleStarOn16, IconToggleStarOn24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

type TChatHeaderUnMarkStarredButton = {
  isMobile: boolean;
  onClick: () => void;
};

export const ChatHeaderUnMarkStarredButton: React.FC<TChatHeaderUnMarkStarredButton> = ({ isMobile, onClick }) => {
  return isMobile ? (
    <IconButton
      onClick={onClick}
      icon={<IconToggleStarOn24 color="icon-main-default" />}
      data-testid="ChatHeaderUnMarkStarredButton"
    />
  ) : (
    <IconButton onClick={onClick} icon={<IconToggleStarOn16 />} data-testid="ChatHeaderUnMarkStarredButton" />
  );
};
